/** Get a particular redux state / reducer */

const StoreSelectors = {
    USER_STATE : (state: any) => state.authentication,
    ALERT_STATE : (state: any) => state.alertState,
    LOADER_STATE: (state: any) => state.loaderState,
    LISTING_STATE: (state: any) => state.APIListingState,
    SELECTED_STATE: (state: any) => state.selectedAPIs,
    PAGE_STATE: (state: any) => state.pageData,
    CHART_STATE: (state: any) => state.chartState,
    TOAST_STATE: (state: any) => state.toastState
}

export default StoreSelectors